module.exports = __webpack_public_path__ + "static/media/escudoUnal_black.f6381588.png";